import dayjs, { Dayjs } from 'dayjs';
import { DateTimeRangeInput } from '../../../../../gql/graphql';

type MetricRanges = Readonly<{
	compareRange: DateTimeRangeInput;
	targetRange: DateTimeRangeInput;
}>;

const formatDate = (date: Dayjs): string => {
	return `${date.format('YYYY-MM-DD')}T00:00:00Z`;
};

const getRangesWithDefault = (filterRange: DateTimeRangeInput | undefined): MetricRanges => {
	/*
	 * Ranges on backend are implemented as
	 * - `start`, which is inclusive (start date is part of the range)
	 * - `end`, which is exclusive (end date is NOT part of the range)
	 *
	 * To determine whether a particular date falls into the range, the following must hold:
	 * `start <= value && value < end`
	 *
	 * In order to show values from the current day by default,
	 * we need to calculate range end as a midnight of the following date (add 1 day to the current date).
	 *
	 * To make the range 7 days long, the start date must be 7 days before the end date
	 * (subtract 7 days from tomorrow => subtract 6 days from the current date).
	 */
	const targetRange = filterRange ?? {
		start: formatDate(dayjs().subtract(6, 'days')),
		end: formatDate(dayjs().add(1, 'days')),
	};

	const rangeSpanInDays = dayjs(targetRange.end).diff(dayjs(targetRange.start), 'days');

	const compareRange = {
		start: formatDate(dayjs(targetRange.start).subtract(rangeSpanInDays, 'days')),
		end: targetRange.start,
	};

	return {
		compareRange,
		targetRange,
	};
};

export { getRangesWithDefault };
